// extracted by mini-css-extract-plugin
module.exports = {"content":"MeshBotNameBlock_content__z_h9m","serial_wrapper":"MeshBotNameBlock_serial_wrapper__1gEHD","inputWrap":"MeshBotNameBlock_inputWrap__1gsLN"};